import { notifyMsmeWorkspaceUpdated } from '../constants/workspaceEvents';
import { clearApiRequestCache } from './apiRequestCache';

/** Clears cached reads without notifying workspace listeners. */
export function clearWorkspaceReadCaches(): void {
  clearApiRequestCache('GET:/msme/');
  clearApiRequestCache('GET:/carbon/');
  clearApiRequestCache('GET:/carbon-credits/');
  clearApiRequestCache('GET:/reporting/');
  clearApiRequestCache('GET:/compliance-hub/');
  clearApiRequestCache('GET:/finance/');
  clearApiRequestCache('GET:/documents');
}

/** Clears cached MSME profile/stats reads and notifies workspace listeners. */
export function invalidateMsmeReadCache(): void {
  clearApiRequestCache('GET:/msme/');
  notifyMsmeWorkspaceUpdated();
}

/** Clears cached carbon and carbon-credits reads. */
export function invalidateCarbonReadCache(): void {
  clearApiRequestCache('GET:/carbon/');
  clearApiRequestCache('GET:/carbon-credits/');
  notifyMsmeWorkspaceUpdated();
}

/** Clears cached reporting reads. */
export function invalidateReportingReadCache(): void {
  clearApiRequestCache('GET:/reporting/');
}

/** Clears cached compliance hub reads. */
export function invalidateComplianceReadCache(): void {
  clearApiRequestCache('GET:/compliance-hub/');
}

/** Clears cached finance overview reads. */
export function invalidateFinanceReadCache(): void {
  clearApiRequestCache('GET:/finance/');
}

/** Clears cached document list/detail/stats reads. */
export function invalidateDocumentsReadCache(): void {
  clearApiRequestCache('GET:/documents');
}

/**
 * Broad invalidation after workspace mutations (uploads, assessments, imports).
 * Keeps legacy ApiService TTL cache and DOM workspace event in sync with React Query.
 */
export function invalidateAllWorkspaceReadCaches(): void {
  clearWorkspaceReadCaches();
  notifyMsmeWorkspaceUpdated();
}
